import React from 'react'
import {injectIntl, defineMessages} from 'react-intl'

import I18nSelect from './I18nSelect'

import selectionProps from '../utils/selectionProps'

const BathroomField = ({value, onChange, intl}) => {
  const messages = defineMessages({
    "0": {id: 'Bathrooms',  defaultMessage: 'Bathrooms'},
    "1": {id: '1 Bathroom +',  defaultMessage: '1 Bathroom +'},
    "2": {id: '2 Bathrooms +', defaultMessage: '2 Bathrooms +'},
    "3": {id: '3 Bathrooms +', defaultMessage: '3 Bathrooms +'},
    "4": {id: '4 Bathrooms +', defaultMessage: '4 Bathrooms +'},
    "5": {id: '5 Bathrooms +', defaultMessage: '5 Bathrooms +'},
  })

  const options = [
    {value: 0, label: intl.formatMessage(messages['0'])},
    {value: 1, label: intl.formatMessage(messages['1'])},
    {value: 2, label: intl.formatMessage(messages['2'])},
    {value: 3, label: intl.formatMessage(messages['3'])},
    {value: 4, label: intl.formatMessage(messages['4'])},
    {value: 5, label: intl.formatMessage(messages['5'])},
  ]
  
  return <I18nSelect className="bathrooms"
                     value={value}
                     options={options}
                     onChange={onChange}
                     multi={false}
                     simpleValue={true}
                     clearable={false}
                     searchable={false}/>
}
export default injectIntl(BathroomField)




/** WEBPACK FOOTER **
 ** ./app/components/BathroomField.jsx
 **/